/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Payment_Terms_PenaltyInputs */

const en_clients_payment_terms_penalty = /** @type {(inputs: Clients_Payment_Terms_PenaltyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Penalty (%)`)
};

const pt_br2_clients_payment_terms_penalty = /** @type {(inputs: Clients_Payment_Terms_PenaltyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Multa (%)`)
};

/**
* | output |
* | --- |
* | "Penalty (%)" |
*
* @param {Clients_Payment_Terms_PenaltyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_payment_terms_penalty = /** @type {((inputs?: Clients_Payment_Terms_PenaltyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Payment_Terms_PenaltyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_payment_terms_penalty(inputs)
	return pt_br2_clients_payment_terms_penalty(inputs)
});